<app-sub-navbar></app-sub-navbar>

<!-- Banner Background -->
<section
  [style.background-image]="'url(' + slidesData[0]?.bannerUrl + ')'"
  class="header-filter-collection py-5 view-more-collection-banner text-center"
>
  <div class="container header">
    <div class="row py-lg-5">
      <div class="col-lg-6 col-md-8 mx-auto">
        <h1 class="fw-semi">Exclusive Collections</h1>
        <p class="lead text-white">
          Discover and follow the
          <span class="fw-bold">Exclusive Collections</span>
        </p>
      </div>
    </div>
  </div>
</section>

<!-- content -->

<section class="py-4">
  <div class="container">
    <div class="row row-cols-lg-4 py-3">
      <div
        class="col-md-4 col-sm-6 col-6 mb-4"
        *ngFor="let data of exclusiveData"
      >
        <a *ngIf="getSEOImage(data.thumbUrl)" [routerLink]="'/illustration-collection/' + data.slug">
          <div class="card collection-radius">
           
             <img [src]="getSEOImage(data.thumbUrl)" class="img-fluid rounded-top skeleton--image " [alt]="data.collectionName"
                  (load)="data.loader = true" />
            <div class="card-body border-top">
                <ng-container *ngIf="data.loader; else skeletonText">
                    <p class="overflow-text fw-semi text-dark card-text">
                      {{ data.collectionName }}
                    </p>
                  </ng-container>

                  <ng-template #skeletonText>
                    <p class="skeleton--text short mb-0"></p>
                  </ng-template>
              <!-- <small class="text-muted">
                  {{ exclusiveData.length }} Illustrations
                </small> -->
            </div>
          </div>
        </a>
      </div>
      <div
        class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center"
        *ngIf="exclusiveData.length === 0"
      >
        <p><b>No data found.</b></p>
      </div>
    </div>
    <!-- 
    <div class="py-3 pad-top px-4 text-center">
      <a routerLink="/" class="btn btn-ib-red">
        Next Page &nbsp;<i class="fas fa-arrow-right"></i
      ></a>
    </div> -->
  </div>
</section>
